import { resource, RequestConfig } from '../helper/resource';

/**
 * [No Auth]幸福100基金经理详情页
 */
export function queryFundManagerDetailUsingPOST(
  req: ManagerDetailParam | void,
  config?: RequestConfig
): Promise<ApiResultLcFundManagerDetailDto> {
  return resource.postNoAuth('/fundManagerDetail/queryFundManagerDetail', req, config);
}

/**
 * [No Auth]幸福100基金经理详情页-深度报告详情
 */
export function queryFundManagerReportUsingPOST(
  req: FixedZoneDetailParam | void,
  config?: RequestConfig
): Promise<ApiResultLcReportDetailDto> {
  return resource.postNoAuth('/fundManagerDetail/queryFundManagerReport', req, config);
}

/**
 * [No Auth]华贵30基金经理详情页
 */
export function queryHg30ManagerDetailUsingPOST(
  req: ManagerPrivateParam | void,
  config?: RequestConfig
): Promise<ApiResultManagerDetailVo> {
  return resource.postNoAuth('/fundManagerDetail/queryHg30ManagerDetail', req, config);
}
